import { IntlShape } from "react-intl";

/**
 * Maps API errors from public registration to user-facing copy.
 * Email-already-taken keeps a dedicated message; other failures show server text or a generic fallback.
 */
export function registerErrorToastMessage(
  error: unknown,
  intl: IntlShape
): string {
  const err = error as {
    response?: { status?: number; data?: { message?: string | string[] } };
  };
  const status = err?.response?.status;
  const raw = err?.response?.data?.message;
  const msgStr =
    typeof raw === "string"
      ? raw.trim()
      : Array.isArray(raw)
      ? raw.map(String).join(" ").trim()
      : "";

  if (
    status === 403 &&
    /email/i.test(msgStr) &&
    /already|exist/i.test(msgStr)
  ) {
    return intl.formatMessage({ id: "app.toast.error59" });
  }

  if (msgStr.length > 0 && msgStr.length < 500) {
    return msgStr;
  }

  return intl.formatMessage({ id: "app.toast.registerGenericError" });
}
